import $ from '../../../../../FrontendBundle/Resources/js/jquery';
import AbstractField from './abstractField';

/**
 * @class ButtonField
 */
export default class ButtonField extends AbstractField {
    type = 'button';

    /**
     * `<div/>` container of field
     *
     * @property {jQuery} control
     */

    /**
     * Element of field
     *
     * @property {jQuery} button
     */

    /**
     * Initializes the field
     *
     * @param {jQuery} control `<div/>` container of field
     * @param {Object} translations
     */
    constructor(control, translations) {
        super(control, translations);

        this.button = $('.btn', control);
        this.value = null;

        this.assertElementIsUnique(this.button, this.type, 'button');
        this.registerEventsForButton(this.button);
    }

    /**
     * Register click event on button.
     */
    registerEventsForButton() {}
}
